import { Link, useLocation } from "react-router-dom";
import { scrollToSection } from "@/lib/scroll";

export const LogoMark = ({ size = 36 }) => (
  <svg width={size} height={size} viewBox="0 0 64 64" fill="none" aria-hidden="true">
    <rect width="64" height="64" rx="14" fill="#111827" />
    <rect x="2" y="2" width="60" height="60" rx="12" stroke="#00F0FF" strokeOpacity="0.55" strokeWidth="3" fill="none" />
    <path d="M19 46V18h11a8 8 0 0 1 0 16h-11" stroke="#00F0FF" strokeWidth="4.5" strokeLinecap="round" strokeLinejoin="round" fill="none" />
    <path d="M30 34 44 46" stroke="#00F0FF" strokeWidth="4.5" strokeLinecap="round" />
    <circle cx="47" cy="19" r="4" fill="#2563EB" />
  </svg>
);

export default function Logo() {
  const location = useLocation();
  const goHome = (e) => {
    if (location.pathname !== "/") return;
    e.preventDefault();
    scrollToSection("#top");
  };
  return (
    <Link to="/" data-testid="logo-home-link" onClick={goHome} className="flex items-center gap-3 group">
      <LogoMark />
      <span className="hidden sm:block leading-tight">
        <span className="font-display font-bold tracking-[0.12em] text-white text-sm block transition-colors duration-300 group-hover:text-[#00F0FF]">
          ROBERT DANIELS
        </span>
        <span className="font-mono text-[10px] uppercase tracking-[0.28em] text-[#9CA3AF]">
          MRP · Inventory Control
        </span>
      </span>
    </Link>
  );
}
